module.exports = {
      id: "icon-play-usage",
      viewBox: "0 0 17.037 21.916",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-play",
      toString: function () {
        return this.url;
      }
    }